document.addEventListener("DOMContentLoaded", function () {

    function _getCookie(t) {
        let e = document.cookie.match(new RegExp("(?:^|; )" + t.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
        return e ? e[1] : false
    }
    const euCountries = ["UK", "FR", "ES", "DE"],
        intlCountries = ["AU", "TH", "AR", "CL", "IL", "AE", "JP", "SG", "NZ", "IN"];

    function checkCountry() {
        console.info(`checkCountry`);

        let subdomain = location.hostname.split('.').shift();
        if (subdomain === 'choosemuse') subdomain = 'us';

        localStorage.setItem('subdomainCountryCode', subdomain);

        const userCountry = localStorage.getItem('ip_country');
        const museLocation = localStorage.getItem('muse_location');
        const storeCountry = _getCookie("_muse_store");

        console.log('subdomainCountry', subdomain, "ipCountry", userCountry, "cookie", storeCountry, "museLocation", museLocation);

        if (userCountry && (userCountry.toLocaleLowerCase() === storeCountry || museLocation === storeCountry)) {
            console.info(`checkCountry > User is in ${userCountry} and in ${storeCountry.toUpperCase()} Store`);
            return;
        }

        const apiUrl = `http://api.ipstack.com/check?access_key=f3287ae9e3cbb4c36c2cfff6b8b9fe28`;
        fetch(apiUrl, {
            method: "POST",
            headers: {}
        }).then(res => res.json()).then(res => {
            const countryCode = res.country_code;
            localStorage.setItem('ipCountryCode', countryCode);
            const isEuCountry = euCountries.find(country => country === countryCode);
            const isIntlCountry = intlCountries.find(country => country === countryCode);

            if (countryCode && localStorage.setItem('ip_country', countryCode)) {
                if (countryCode.toLowerCase() !== storeCountry || isEuCountry && storeCountry !== "eu" || isIntlCountry && storeCountry !== "intl") {
                    console.info(`checkCountry > User is in ${countryCode}`);
                }
            }

            console.log("Check Country Finished");
        });
    }
    checkCountry();

    const setRegion = () => {
        const redirectPages = ["/cart", "/checkout", "/products", "/pages/premium-subscription", "/pages/muse-connect", "/pages/compare", "/pages/shop", "/pages/shop-in-bulk", "/pages/shop-accessories"];
        let _countryCode = _getCookie("_muse_store");
        const storeTexts = document.querySelectorAll("span.header__store-content");
        const storeFlags = document.querySelectorAll("img.header__store-flag");
        console.log("countryCode", _countryCode);
        if (!_countryCode) _countryCode = localStorage.getItem('subdomainCountryCode');
        if (!_countryCode) _countryCode = 'us';
        storeFlags.forEach(S => {
            const newSrcWords = S.src.split('/');
            const flagWords = newSrcWords[8].split('-');
            flagWords[0] = _countryCode;
            newSrcWords[8] = flagWords.join('-');
            const newSrc = newSrcWords.join('/');
            S.src = newSrc;
            S.style.display = 'block';
        })
        storeTexts.forEach(S => {
            S.textContent = _countryCode === "eu" ? "EU / UK Store" : `${_countryCode.toUpperCase()} Store`
            S.style.display = 'block';
        });
        if (_countryCode.toUpperCase() == 'US') _countryCode = ''
        else _countryCode = `${_countryCode}.`
        // redirectPages.forEach(link => {
        //     document.querySelectorAll('a[href]').forEach(elem => {
        //         if (elem.href.includes(link)) {
        //             elem.href = `https://${_countryCode}choosemuse.com${link}`;
        //         }
        //     })
        // })
    }

    window.onload = setRegion;
});
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

function clearChooseMuseStorage() {
  try {
    const isFirstLoad = localStorage.getItem('initialized');
    
    if (!isFirstLoad) {
      const klipSession = getCookie('klip-session_uid');
      
      if (klipSession) {
        console.log('Clearing choosemuse storage...');
        
        // Get all localStorage keys
        const keysToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          
          // Check if key contains choosemuse-related data
          if (key.includes('choosemuse') || 
              // key.includes('Chatra') || 
              key.includes('muse') ||
              // key.includes('cart') ||
              key.includes('klip')
              // key.includes('magical_fees') ||
              // key.includes('revyCart') ||
              // key.includes('trackedSourceId') ||
              // key.includes('extensionStorage') ||
              // key.includes('__ui')
              ) {
            keysToRemove.push(key);
          }
        }
        
        // Remove all identified keys
        keysToRemove.forEach(key => {
          console.log('Removing:', key);
          localStorage.removeItem(key);
        });
        
        // Clear sessionStorage too
        sessionStorage.clear();
        
        console.log(`Cleared ${keysToRemove.length} choosemuse items`);
      }
      
      localStorage.setItem('initialized', 'true');
    }
  } catch (error) {
    console.error('Error during storage clear:', error);
  }
}

// Run on page load
clearChooseMuseStorage();

// Advanced sticky navbar with coordinate tracking
(function() {
    const navbar = document.querySelector('.v2-floating-header__navbar');
    const container = document.querySelector('.v2-floating-header__container');
    
    if (!navbar || !container) return;
    
    // Fixed sticky threshold
    const STICKY_THRESHOLD = 494;
    
    let navbarData = {
        height: 0,
        isSticky: false
    };
    
    function init() {
        // DON'T remove sticky class on init - just measure
        const navbarRect = navbar.getBoundingClientRect();
        navbarData.height = navbarRect.height;
        
        // Reset the isSticky flag based on current class state
        navbarData.isSticky = navbar.classList.contains('is-sticky');
        
        checkScroll();
    }
    
    function checkScroll() {
        const currentScroll = window.scrollY;

        // console.log(
        //     'Current Scroll:', currentScroll,
        //     'Threshold:', STICKY_THRESHOLD,
        //     'Is Sticky:', navbarData.isSticky
        // );

        // Add sticky when scroll >= 494
        if (currentScroll >= STICKY_THRESHOLD) {
            if (!navbarData.isSticky) {
                navbar.classList.add('is-sticky');
                navbarData.isSticky = true;
                // console.log('✓ Added is-sticky');
            }
        } 
        // Remove sticky when scroll < 494
        else {
            if (navbarData.isSticky) {
                navbar.classList.remove('is-sticky');
                navbarData.isSticky = false;
                // console.log('✗ Removed is-sticky');
            }
        }
    }
    
    // Throttle scroll events
    let ticking = false;
    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                checkScroll();
                ticking = false;
            });
            ticking = true;
        }
    }
    
    // Initialize
    init();
    
    // Event listeners
    window.addEventListener('scroll', onScroll, { passive: true });
    
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(init, 250);
    });
    // Expose data for debugging
    window.navbarDebug = navbarData;
})();
